<template lang="pug">
    ul(:class="{'line': showLine && level > 1, 'none': !expandAll && level > 1}")
        li(v-for="(item, index) in data", tabindex="0", :data-key="item[nodeKey]")
            span.tree-button.switch(:class="[className(item, index)]", @click.stop="handleSwitchClick(item, $event)")
            span.tree-button.chk.checkbox_false_full(v-if="showCheckbox", @click.stop="handleNodeCbxClick(item, $event)")
            a(v-if="contextmenu", :title="item[defaultProps.label]", @click.stop="handleNodeClick(item, $event)", @contextmenu.prevent="handleRightMenu(item, $event)")
                i.fa(v-if="item[defaultProps.icon]", :class="[item[defaultProps.icon]]", style="margin: 0 5px")
                span.node_name {{item[defaultProps.label]}}
            a(v-else, :title="item[defaultProps.label]", @click.stop="handleNodeClick(item, $event)")
                i.fa.mr5(v-if="item[defaultProps.icon]", :class="[item[defaultProps.icon]]", style="margin: 0 5px")
                span.node_name {{item[defaultProps.label]}}    
            hz-tree-item(v-if="item[defaultProps.children] && item[defaultProps.children].length", :data="item[defaultProps.children]", :level="level+1")    
</template>
<script>
import Emitter from './util/emitter'    
export default {
    name: 'hz-tree-item',
    inject: ['expandAll', 'showLine', 'showCheckbox', 'defaultProps', 'nodeKey', 'contextmenu', 'checkRelate', 'lazy', 'multiple'],
    mixins: [Emitter],
    props: {
        level : { type: Number, default: 1},
        data  : { type: Array, default: function(){ return [] }}
    },
    data(){
        return {
        }
    },
    created(){
    },
    methods: {
        className(item, index){
            let className = this.showLine ? 'center_' : 'noline_';
            const children = this.defaultProps.children;
            const isLeaf = this.defaultProps.isLeaf;
            if(this.lazy){
                return item[isLeaf] ? `${className}docu` : `${className}close`
            } else if(item[children] && item[children].length){
                return this.expandAll ? `${className}open` : `${className}close`
            }else{
                return `${className}docu`
            }

        },
        //右键菜单点击事件
        handleRightMenu(item, e){
            this.dispatch('hz-tree', 'rightMenu', {item, e})
        },
        handleSwitchClick(item, e){
            const $el = $(e.target)
            let className = this.showLine ? 'center_' : 'noline_';

            if($el.hasClass(`${className}open`)){
                $el.nextAll('ul').slideUp("fast");
                $el.toggleClass(`${className}open ${className}close`)
            }else{
                if(this.lazy && (!item.children || !item.children.length)){
                    $el.parent().append('<i class="fa fa-spinner ml10 zSpin"></i>')
                    this.dispatch('hz-tree', 'node-lazy', item, res => {
                        this.$set(item, 'children', res);
                        $el.parent().find("i.fa.fa-spinner").remove()
                        this.$nextTick(_ => {
                            $el.nextAll('ul').slideDown("fast");
                            $el.toggleClass(`${className}open ${className}close`)
                        })
                    })
                }else{
                    $el.nextAll('ul').slideDown("fast");
                    $el.toggleClass(`${className}open ${className}close`)
                }
            }
            
        },
        handleNodeClick(item, e){
            if(item.disabled) return ;
            const $el = $(e.target).closest("a");
            if(!this.multiple){
                $el.closest(".hz-tree").find(".curSelectedNode").removeClass("curSelectedNode")
            }
            $el.addClass("curSelectedNode")
            this.dispatch('hz-tree', 'node-click', item)
        },
        handleNodeCbxClick(item, e){
            const $el = $(e.target)
            const $parent = $el.parent();
            if($el.hasClass("checkbox_false_disable")) return;
            if(this.checkRelate){
                if($el.hasClass("checkbox_true_full")){
                    //未选中
                    $parent.find(".chk").removeClass("checkbox_true_full").addClass("checkbox_false_full");
                    $el.closest("ul").parents("li").children(".chk").removeClass("checkbox_true_full");
                }else{
                    //选中
                    $parent.find(".chk").removeClass("checkbox_false_full").addClass("checkbox_true_full");
                    $el.closest("ul").parents("li").each(function(index, item){
                        var $item = $(item);
                        ([].every).call($item.find("ul .chk"), function(cbx){
                            return $(cbx).hasClass("checkbox_true_full");
                        }) ? $item.children(".chk").removeClass("checkbox_false_full").addClass("checkbox_true_full") : null;
                    });
                }
            }else{
                $el.toggleClass("checkbox_true_full checkbox_false_full")
            }
            const flag = $el.hasClass("checkbox_true_full");
            this.dispatch("hz-tree", "check-click", item, flag);
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/treeItem.vue